import gsap from "gsap";
import ScrollSmoother from "gsap/ScrollSmoother";
import ScrollTrigger from "gsap/ScrollTrigger";
import { hide } from "./animations/hide";
import { smootherPause } from "./smoother";


gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

export const leadspaceHome = () => {
    const logo = document.querySelector('.navbar__intro-logo');
    const tl = gsap.timeline();
    let val, breakPoint = 900;

    hide('.navbar__logo');

    ScrollTrigger.defaults({
        trigger: '.leadspace-home',
        start: '0 0',
        end: 'bottom 0',
        scrub: true,
    })

    gsap.matchMedia().add(
        {
            isDesktop: `(min-width: ${breakPoint}px)`,
            isTablet: `(min-width: ${breakPoint - 300}px)`,
            isMobile: `(max-width: ${breakPoint - 300 - 1}px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)"
        }, 
        (context) => {
            let { isDesktop, isMobile, isTablet, reduceMotion } = context.conditions;

            val = isDesktop ? '5% top' : '15% top';

            tl.from(logo, {
                top: isDesktop ? '43vh' : '25vh',
                scale: isDesktop ? 5.5 : isTablet ? 4 : isMobile ? 3 : '',
                y: isDesktop ? '-43%' : '-25%',
                force3D: false,
                scrollTrigger: {
                    trigger: '.leadspace-home__logo',
                    pin: true,
                    endTrigger: '.leadspace-home'
                },
            })
            .to(logo, {
                scrollTrigger: {
                    pin: true,
                    pinSpacing: false,
                    start: '100% top',
                    end: 'bottom 0',
                    endTrigger: '.theme-container',
                    scrub: false
                },
            })
            return () => {}
        }
    ); 

    tl
    .to('.leadspace-home__text', {
        y: '10rem',
        autoAlpha: 0,
        scrollTrigger: {
            end: '10% top'
        }
    })
    .to('.leadspace-home__bg img', {
        y: '5rem',
        scrollTrigger: {}
    })
    .to('.leadspace-home__fork figure', {
        y: '100%',
        duration: 0.2,
        scrollTrigger: {
            start: '0.5% top',
            end: val,
            onEnterBack: () => {
                gsap.set('.leadspace-home__fork', {
                    display: 'block'
                })
            }
        },
        onComplete: () => {
            gsap.set('.leadspace-home__fork', {
                display: 'none'
            })
        }
    })

    gsap.to('.leadspace-home__fork', {
        scrollTrigger: {
            trigger: '.leadspace-home__fork',
            endTrigger: '.theme-container',
            start: 'top 100%',
            pin: true,
            pinSpacing: false
        }
    })
    
    document.querySelector('.scroll-btn').addEventListener('click', () => {
        window.scrollTo(0, document.querySelector('.leadspace-home').clientHeight);
    })
}

export const resetTransform = () => {
    gsap.set('.theme-container', {
        y: 0
    })
}

export const introAnimate = () => {
    const tl = gsap.timeline({
        defaults: {
            duration: 0.3
        }
    });

    tl.set('.leadspace-home__logo svg', {
        autoAlpha: 0,
        xPercent: -18,
        yPercent: 20,
        rotation: -20,
        transformOrigin: '50% 50%',
    })
    .set('.leadspace-home__bg', {
        autoAlpha: 0,
        scale: 1.2
    })
    .set('.leadspace-home__text figure', {
        y: '10rem',
        autoAlpha: 0
    })
    .set('.navbar', {
        y: '-100%'
    })
    .set('.leadspace-home__btn', {
        y: '100%'
    })
    

    tl
    .to('.leadspace-home__logo svg', {
        autoAlpha: 1,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        delay: 1,
        force3D: false
    })
    .to('.leadspace-home__bg', {
        autoAlpha: 1,
        scale: 1,
        duration: 0.6
    }, "+=0.6")
    .to('.leadspace-home__text figure', {
        y: 0,
        autoAlpha: 1
    }, '<')
    .to('.leadspace-home__fork img', {
        y: '-100%'
    }, '<')
    .to('.navbar', {
        y: 0
    }, '<')
    .to('.leadspace-home__btn', {
        y: 0,
        onComplete: () => {
            setTimeout(() => {
                smootherPause(false);
            }, 600)
        }
    }, '<')
}

export const bottomBar = () => {
    const tl = gsap.timeline();
    const select = document.querySelector('.bottom-bar');
    gsap.to('.bottom-bar__fork', {
        y: '0',
        duration: 0.3,
        scrollTrigger: {
            trigger: '.bottom-bar__fork',
            start: '-200% 20%',
            end: '-200% 10%',
            scrub: true
        }
    })
}
